import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { CustomValidators, matchingPasswords } from 'app/utils/helper';
import { AuthService } from 'app/core/auth/auth.service';
import BusinessPartnerTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity';
import { MatSelectModule } from '@angular/material/select';
import { OrdersCreationService } from 'app/modules/components/sales/order-generate/order-generate.service';
import { IRequestResult } from 'app/common/interfaces';
import { MasterUserInterface } from 'app/modules/components/sales/order-generate/interfaces/master-user.interface';
import { buildQuery, Ops, where } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { MastersUserAttributes } from '@albatrosdeveloper/ave-models-package';
import { UserMasterService } from 'app/modules/components/routing/sub-routes/sub-route-collaborator/user_master.service';

@Component({
  selector: 'app-password-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatSlideToggleModule,
    MatIconModule,
    MatSelectModule
  ],
  templateUrl: './password-modal.component.html',
})
export class PasswordModalComponent {

  form: FormGroup;
  password = new FormControl(null)
  password_confirmation = new FormControl(null)

  hide:boolean = false
  hideold:boolean = false
  hidenew:boolean = false

  businessPartnerFilterTypeList: BusinessPartnerTypeAttributes[] = []
  applicationList: any[] = []

  editPassword: boolean = true
  old_password = null
  user = null

  constructor(
    private authService: AuthService,
    private userMasterService: UserMasterService,
    private readonly ordersCreationService: OrdersCreationService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<PasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BusinessPartnerAttributes
  ) { 
    this.form = this.formBuilder.group({
      password: this.password,
      password_confirmation: this.password_confirmation,
    }, {
      validator: matchingPasswords('password', 'password_confirmation') 
    });
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("70%")
    this.getInfoUser()
    this.initForm()
  }

  getInfoUser(){
    this.user = this.authService.user
  }

  initForm(user?){
    if(user){
      this.password.setValidators([
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(3),
      ]);
  
      this.password_confirmation.setValidators([]);
    }
    this.cdr.detectChanges();
  }

  compareFn = (option: any, value: any): boolean => {
    return option?.parentId === value?.parentId && option?.subId === value?.subId;
  };


  onPasswordChange(){
    this.password.setValue(null)
    this.password_confirmation.setValue(null)
  }

  onSubmit(){
    if(!this.form.valid){
      return;
    }

    if(!this.user){
      this.snackBar.open("Usuario no encontrado", "Cerrar", {duration: 3000,});
      return;
    }
    
    if(this.editPassword && (this.password.value == null || this.password_confirmation.value == null)){
      return;
    }


    let info: any = {
      user_login_id: String(this.user._id),
      //business_partner_id: String(this.data._id),      
      email: this.user.email?.trim()?.toLowerCase(),
      oldPass: null,
      newPass: this.password.value?.trim(),
      confirmPass: this.password_confirmation.value?.trim(),
    }
    
    this.userMasterService.updateUser(info, this.user.masterUserId).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 3000,});
        this.dialogRef.close('success')
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 3000 });
      },
    });
  }
}
